import Gallery, { Animation } from '../../Gallery';
import Section, { size } from '../../generic/Section';

import React from 'react';
import RichText from '../../generic/RichText';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';

export default function RoomExperience({ roomExperience, debug = false }) {
  const { heading, subHeading, subsections } = roomExperience;

  if (!subsections) return null;
  return (
    <Section
      className={mergeClassNames(styles.roomExperience, debug ? styles.debug : null)}
      innerClassName={styles.inner}
      size={size.max}
    >
      <div className={styles.headingColumn}>
        <h3 className={styles.heading}>{heading}</h3>
        <RichText className={styles.subHeading}>{subHeading}</RichText>
      </div>

      <Gallery
        slides={subsections.map(subsection => ({
          ...subsection,
          image: { ...subsection.image, ...subsection.image.image },
        }))}
        className={styles.galleryColumn}
        animation={Animation.fade}
        showFullscreenControls={false}
        showDownloadControls={false}
        showArrowControls={false}
      />
    </Section>
  );
}
